import { render, staticRenderFns } from "./ProductNotesDialog.vue?vue&type=template&id=226b819e&scoped=true&lang=pug&"
import script from "./ProductNotesDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductNotesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductNotesDialog.vue?vue&type=style&index=0&id=226b819e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b819e",
  null
  
)

export default component.exports